import type { RecordingDeviceCopy } from './recording-device-copy';
import { deviceCategories, microphoneTypes, recordingDeviceCategoryFromValue, recordingDeviceDetailsRequired, recordingMicrophoneTypeFromValue, type RecordingDeviceSelection } from './recording-device-metadata';

type Props = {
  copy: RecordingDeviceCopy;
  value: RecordingDeviceSelection;
  onChange: (value: RecordingDeviceSelection) => void;
  idPrefix: string;
};

export function RecordingDeviceFields({ copy, value, onChange, idPrefix }: Props) {
  const detailsRequired = recordingDeviceDetailsRequired(value);
  const detailsLength = Array.from(value.recordingDeviceDetails.trim()).length;
  const showDetailsError = detailsRequired && (detailsLength < 2 || detailsLength > 80);

  return (
    <fieldset className="space-y-3">
      <legend className="sr-only">{copy.categoryLabel}</legend>
      <div className="space-y-2">
        <label htmlFor={`${idPrefix}-category`} className="text-sm font-medium text-foreground">{copy.categoryLabel}</label>
        <select
          id={`${idPrefix}-category`}
          required
          value={value.recordingDeviceCategory}
            onChange={(event) => onChange({ ...value, recordingDeviceCategory: recordingDeviceCategoryFromValue(event.target.value) })}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        >
          <option value="">{copy.categoryPlaceholder}</option>
          {deviceCategories.map((category) => <option key={category} value={category}>{copy.deviceValues[category]}</option>)}
        </select>
      </div>
      <div className="space-y-2">
        <label htmlFor={`${idPrefix}-microphone`} className="text-sm font-medium text-foreground">{copy.microphoneLabel}</label>
        <select
          id={`${idPrefix}-microphone`}
          required
          value={value.recordingMicrophoneType}
          onChange={(event) => onChange({ ...value, recordingMicrophoneType: recordingMicrophoneTypeFromValue(event.target.value) })}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        >
          <option value="">{copy.microphonePlaceholder}</option>
          {microphoneTypes.map((microphone) => <option key={microphone} value={microphone}>{copy.microphoneValues[microphone]}</option>)}
        </select>
      </div>
      {detailsRequired ? (
        <div className="space-y-2">
          <label htmlFor={`${idPrefix}-details`} className="text-sm font-medium text-foreground">{copy.detailsLabel}</label>
          <input
            id={`${idPrefix}-details`}
            required
            minLength={2}
            maxLength={160}
            value={value.recordingDeviceDetails}
            onChange={(event) => onChange({ ...value, recordingDeviceDetails: event.target.value })}
            placeholder={copy.detailsPlaceholder}
            aria-describedby={`${idPrefix}-details-error`}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          />
          {showDetailsError ? <p id={`${idPrefix}-details-error`} className="text-sm text-destructive">{copy.detailsRequired}</p> : null}
        </div>
      ) : null}
    </fieldset>
  );
}
